var path = 'app/portainer/components/date-range-picker/date-range-picker.html';
var html = "<input ng-class=\"className\" id=\"{{ id }}\" />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;